import React, { useEffect, useState } from "react";
import styles from './ApproveInstructorForm.module.scss';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import PropTypes from "prop-types";
import Button from "../button/Button";
import TextField from "../textField/TextField";
import { formatPhoneNumber } from "../../utils/stringUtils";

const ApproveInstructorForm = ({
  instructor,
  onCancel,
  onSubmit,
  isLoading
}) => {
  const [firstName, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => {
    setFirstName(instructor.firstName || '');
    setLastName(instructor.lastName || '');
    setEmail(instructor.email || '');
  }, [instructor])
  
  const validateFirstName = () => {
    if(!firstName) {
      return 'First Name is required';
    }
    if(!/^[A-Za-z]{2}/.test(firstName)) {
      return 'First Name must contain only letters and be at least 2 characters long.'
    }
    return '';
  }
  
  const validateLastName = () => {
    if(!lastName) {
      return 'Last Name is required';
    }
    if(!/^[A-Za-z]{2}/.test(lastName)) {
      return 'Last Name must contain only letters and be at least 2 characters long.'
    }
    return '';
  }

  const validateEmail = () => {
    if(!email) {
      return 'Email is required';
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!regex.test(email)) {
      return 'Email is invalid';
    }
    return '';
  };

  const validatePhone = () => {
    const cleanedValue = phone.replace(/\D/g, '');
    if (!cleanedValue) {
      return 'Phone number is required';
    }
    if (!/^\d{10}$/.test(cleanedValue)) {
      return 'Invalid phone number format. Must be 10 digits.';
    }
    return '';
  };

  const handleSubmit = () => {
    const firstNameValidationResult = validateFirstName();
    const lastNameValidationResult = validateLastName();
    const emailValidationResult = validateEmail();
    const phoneValidationResult = validatePhone();

    setFirstNameError(firstNameValidationResult);
    setLastNameError(lastNameValidationResult);
    setEmailError(emailValidationResult);
    setPhoneError(phoneValidationResult);

    if (firstNameValidationResult || lastNameValidationResult || 
      emailValidationResult || phoneValidationResult) {
      return false;
    }

    onSubmit({
      firstName,
      lastName,
      email,
      mobileNumber: phone.replace(/\D/g, '')
    });
  };

  return (
    <form 
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <h3>Approve Instructor</h3>
      </div>
      <div className={styles.createForm}>
        <div className={styles.row}>
          <div className={styles.column}>
            <TextField
              label="First Name"
              value={firstName}
              onChange={(value) => setFirstName(value)}
              error={firstNameError}
            />
          </div>
          <div className={styles.column}>
            <TextField
              label="Last Name"
              value={lastName}
              onChange={(value) => setLastName(value)}
              error={lastNameError}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.column}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(value) => setEmail(value)}
              error={emailError}
            />
          </div>
          <div className={styles.column}>
            <TextField
              label="Phone"
              value={phone}
              onChange={(value) => setPhone(formatPhoneNumber(value))}
              error={phoneError}
            />
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          label="Cancel"
          variant="secondary"
          size="medium"
          onClick={onCancel}
        />
        <Button
          label="Approve"
          variant="primary" 
          size="medium"
          type="submit"
        />
      </div>
    </form>
  );
};

ApproveInstructorForm.propTypes = {
  instructor: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool
}

export default ApproveInstructorForm;